import { Button } from "components/DesignSystem/Button/Button";
import Slider from "components/DesignSystem/Slider/Slider";
import { useModal } from "hooks/useModal";
import { Shareholder } from "types/Models/Shareholders";
import { DetailField, SectionCard } from "../People/PersonSlider";
import { AddShareholder } from "./AddShareholder";
import { EditDetailsIcon } from "components/icons/EditDetailsIcon";

export const EntityDetailsSlider = ({
  shareholder,
}: {
  shareholder: Shareholder;
}) => {
  const editModal = useModal();
  const entity = shareholder.entity_details;
  const {
    issued_common_stock: issuedCommonStock,
    issued_preferred_stock: issuedPreferredStock,
  } = shareholder;

  return (
    <>
      <Slider.Header>
        <Slider.Title>Entity Details</Slider.Title>
        <Slider.Close />
      </Slider.Header>
      <Slider.Body>
        <SectionCard title="Details">
          <div className="t-flex t-w-full t-flex-col t-gap-6">
            <div className="t-flex t-w-full t-gap-4">
              <DetailField label="Entity name" value={entity?.name || "-"} />
              <DetailField
                label="Ownership stake"
                value={
                  shareholder.ownership_stake != null
                    ? `${shareholder.ownership_stake}%`
                    : "-"
                }
              />
            </div>
            <div className="t-flex t-w-full t-gap-4">
              <DetailField label="Country" value={entity?.country || "-"} />
              <DetailField label="State" value={entity?.state || "-"} />
            </div>
            <div className="t-flex t-w-full t-gap-4">
              <DetailField
                label="Tax residency"
                value={shareholder.country?.name || "-"}
              />
              <DetailField
                label="Formation type"
                value={entity?.formation_type || "-"}
              />
            </div>
            <div className="t-flex t-w-full t-gap-4">
              <DetailField
                label="Issued common stock"
                value={issuedCommonStock?.toLocaleString() ?? "-"}
              />
              <DetailField
                label="Issued preferred stock"
                value={issuedPreferredStock?.toLocaleString() ?? "-"}
              />
            </div>
          </div>
        </SectionCard>
      </Slider.Body>
      <Slider.Footer>
        <Button
          type="button"
          customType="secondary"
          onClick={editModal.open}
          className="!t-h-10 t-w-full !t-justify-center !t-rounded-md !t-border-neutral-10 !t-bg-white !t-text-button !t-text-text-60 !t-shadow-xs"
        >
          <span className="t-inline-flex t-items-center t-gap-1">
            <EditDetailsIcon />
            Edit details
          </span>
        </Button>
      </Slider.Footer>
      {editModal.isOpen && (
        <AddShareholder {...editModal} shareholder={shareholder} />
      )}
    </>
  );
};
